import * as React from 'react';

import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { FontAwesomeKitIcon } from '../../_atomics/FontAwesomeIcon/FontAwesomeKitIcon';
import type { KitIconNames } from '../../_atomics/FontAwesomeIcon/types';

type QuickLinkIconProp =
  | {
      icon: IconProp;
      kitIcon?: undefined;
    }
  | {
      icon?: undefined;
      kitIcon: KitIconNames;
    };

export type QuickLinkSectionItemProps = {
  href: string;
  target?: string;
  title: string;
} & QuickLinkIconProp;

export const QuickLinkSectionItem: React.FC<QuickLinkSectionItemProps> = ({
  href,
  icon,
  kitIcon,
  target,
  title,
}) => {
  const iconStyle = { height: 'auto', width: 16 };
  const Icon = icon ? (
    <FontAwesomeIcon fixedWidth icon={icon} style={iconStyle} />
  ) : (
    <FontAwesomeKitIcon fixedWidth icon={kitIcon} style={iconStyle} />
  );

  return (
    <a className="quick-link-section-item" href={href} target={target}>
      {Icon}
      <span className="quick-link-section-item-title">{title}</span>
    </a>
  );
};
